export const baseURL = process.env.REACT_APP_BASEURL_BACKOFFICE;
export const baseURLV1 = process.env.REACT_APP_BASEURL_BACKOFFICE + '/api/v1';
export const baseURLV2 = process.env.REACT_APP_BASEURL_BACKOFFICE + '/api/v2';
export const imageURL = process.env.REACT_APP_IMAGEURL;
export const privilegeURL = process.env.REACT_APP_PRIVILAGE_URL+ '/api/v1';
export const privilegeImage = process.env.REACT_APP_PRIVILAGE_URL
export const privilegeURLV2 = process.env.REACT_APP_PRIVILAGE_URL+ '/api/v2';
export const campaigns_id_privilage = '19'
export const privilegeURL2 = process.env.REACT_APP_BASEURL_BACKOFFICE+ '/api/v1/privilege';
